'use client'

import { useOldCities, useOldDistrict, useOldWards } from '@/hooks'
import { Control, useWatch } from 'react-hook-form'

export enum AddressCode {
  CITY = 'city_id',
  DISTRICT = 'district_id',
  WARD = 'ward_id',
}

type UseLocationFieldsProps = {
  control: Control<any>
  namePrefix?: string // thêm prefix động cho tên field
}

export const useLocationFields = ({ control, namePrefix = '' }: UseLocationFieldsProps) => {
  // helper để tạo tên động (prefix + trường)
  const buildName = (field: string) => (namePrefix ? `${namePrefix}.${field}` : field)

  const { dataCities, isLoadingDataCitys } = useOldCities()

  const cityValue = (useWatch({ control, name: buildName(AddressCode.CITY) }) as string) || ''
  const { dataDistricts, isLoadingDataDistricts } = useOldDistrict(cityValue)

  const districtValue = (useWatch({ control, name: buildName(AddressCode.DISTRICT) }) as string) || ''
  const { dataWards, isLoadingDataWards } = useOldWards(districtValue)

  return {
    dataCities,
    dataDistricts,
    dataWards,
    isLoadingCitys: isLoadingDataCitys,
    isLoadingDistricts: isLoadingDataDistricts,
    isLoadingWards: isLoadingDataWards,
  }
}
